module.exports = __webpack_public_path__ + "img/cargo-wagon-mask-3.fceb5e46.png";